import { createStore, applyMiddleware, compose } from 'redux';
import thunk from "redux-thunk";
import { combineReducers } from "redux";
import { reducer as formReducer } from 'redux-form'
import doohReportSummary from "../modules/dooh-report/reducer";

import advertiser from "../modules/common/advertiserReducer";
import campaign from "../modules/common/campaignReducer";
import outlet from "../modules/common/outletReducer";
import loader from "../modules/common/loaderReducer";
import user from "../modules/user/reducers/userReducer";
import newUser from "../modules/user/reducers/newUserReducer";
import apps from "../modules/applications/reducers/reducer";
import advertisers from "../modules/applications/reducers/advertserReducer";
import adIdCount from "../modules/analytics/reducers/adIdCountReducer";
import userPreferences from "../modules/analytics/reducers/userPreferencesReducer";
import contentAnalytics from "../modules/analytics/reducers/contentAnalyticsReducer";
import websiteCount from "../modules/analytics/reducers/websiteCountReducer";
import visitAnalytics from "../modules/analytics/reducers/visitAnalyticsReducer";
import engagementByWebsite from "../modules/analytics/reducers/engagementByWebsiteReducer";
import engagementPeakTime from "../modules/analytics/reducers/engagementPeakTimeReducer";
import allWebsites from "../modules/analytics/reducers/allWebsitesReducer";
import exportData from "../modules/analytics/reducers/exportDataReducer";
import permission from "../modules/user/reducers/permissionReducer";
import userClients from "../modules/user/reducers/userClientsReducer";
import dsp from "../modules/dsp-report/reducer";
import Stats from "../modules/ssp-report/reducer"
import { dialogReducer } from '../lib/redux-reactstrap-modal';

import auth from "../modules/auth/reducer";
import { reducer as toastr } from 'react-redux-toastr'

import categories from "../modules/category/reducers/categoryReducer";
import category from "../modules/category/reducers/singleCategoryReducer";
import newCategory from "../modules/category/reducers/newCategoryReducer";
import categoryGroups from "../modules/category/reducers/categoryGroupsReducer";
import categoryGroupsList from "../modules/category/reducers/categoryGroupsListReducer";
import categoryGroup from "../modules/category/reducers/singleCategoryGroupReducer";
import newCategoryGroup from "../modules/category/reducers/newCategoryGroupReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    combineReducers({
        dialogReducer: dialogReducer,
        form: formReducer,
        doohReportSummary,
        auth,
        toastr,
        advertiser,
        campaign,
        outlet,
        loader,
        user,
        newUser,
        permission,
        apps,
        advertisers,
        adIdCount,
        userPreferences,
        contentAnalytics,
        websiteCount,
        visitAnalytics,
        engagementByWebsite,
        engagementPeakTime,
        allWebsites,
        exportData,
        userClients,
        dsp,
        Stats,
        categories,
        category,
        newCategory,
        categoryGroups,
        categoryGroupsList,
        categoryGroup,
        newCategoryGroup,
    }),
    composeEnhancers(
        applyMiddleware(
            thunk
        )
    )
);

export default store;
